import {Component,Input} from '@angular/core';
import {ListViewItem} from "@domain/common/list-view/list-view-item";
import {Tolerance} from '@domain/typecharge/tolerance';
import {NatureVoyage} from "@domain/prestation/nature-voyage";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import {first} from "rxjs/operators";
import {ModifyTolerancesPopinComponent} from "../modify-tolerances-popin/modify-tolerances-popin.component";

/**
 * Item de la liste des tolérances
 *
 * @author Stéphane Chan Tack
 * @date 08/07/2025
 */
@Component({
    host: {'data-test-id': 'factures-tolerances-item'},
    templateUrl: './factures-tolerances-item.component.html'
})
export class FacturesTolerancesItemComponent extends ListViewItem<Tolerance> {
    /** Données de la tolérance */
    @Input() data: Tolerance;

    /**
     * Constructeur
     *
     * @param matDialog Gestionnaire de popin
     */
    constructor(
        private matDialog: MatDialog,
    ) {
        super();
    }

    /**
     * Formatage du pourcentage de tolérance
     */
    getToleranceFormatted(): string {
        if (this.data.tolerance != null) {
            return (this.data.tolerance * 100).toFixed(2) + '%';
        }
        return '';
    }

    /**
     * Retourne l'icone associée à une tolérance en fonction de son code
     * @param code Code de la tolérance
     * @return nom de l'icone
     */
    getIconeFromCode(code: string): string {
        return NatureVoyage.getIcone(code as NatureVoyage);
    }

    /**
     * Ouvre la popin de modification d'une tolérance
     */
    openModifyTolerancePopin(): void {
        //Ouverture de la popin
        this.matDialog.open(ModifyTolerancesPopinComponent, {
            width: '500px',
            data: {
                tolerance: this.data
            }
        }).afterClosed().pipe(first()).subscribe((data: { refresh: boolean}) => {
            if (data.refresh) {
                // Mise à jour de la liste
                this.liste.refresh();
            }
        });
    }
}
